import React from "react"
import { X } from "lucide-react"
import {
  Toast,
  useToast,
} from "../../hooks/use-toast"
import { cn } from "../../lib/utils"

export function Toaster() {
  const { toasts, dismiss } = useToast()

  return (
    <div className="fixed top-0 z-[100] flex max-h-screen w-full flex-col-reverse p-4 sm:bottom-0 sm:right-0 sm:top-auto sm:flex-col md:max-w-[420px]">
      {toasts.map(function ({ id, title, description, action, variant = "default", open = true, ...props }) {
        return (
          <div
            key={id}
            data-state={open ? "open" : "closed"}
            className={cn(
              "relative pointer-events-auto overflow-hidden rounded-md mb-4 w-full shadow-lg transition-all cursor-pointer",
              "animate-in slide-in-from-top-full sm:slide-in-from-bottom-full",
              "hover:shadow-xl transition-shadow",
              variant === "destructive"
                ? "bg-red-600 text-white border-red-700"
                : "bg-background text-foreground border"
            )}
            onClick={() => dismiss(id)}
            {...props}
          >
            <div className="grid gap-1 p-6 pr-12">
              {title && <div className="text-sm font-semibold">{title}</div>}
              {description && (
                <div className="text-sm opacity-90">{description}</div>
              )}
            </div>
            
            {/* Close button */}
            <button
              onClick={(e) => {
                e.stopPropagation()
                dismiss(id)
              }}
              className="absolute top-2 right-2 p-1 rounded-sm opacity-70 hover:opacity-100 transition-opacity"
            >
              <X className="h-4 w-4" />
            </button>
            
            {action && (
              <div className="px-6 pb-4">
                {action}
              </div>
            )}
          </div>
        )
      })}
    </div>
  )
}